import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { IcUniversity, IcPlus, IcEdit } from "../../Icons";
import axios from "axios";
import {
  Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Row, Col,
} from "reactstrap";
import Header from "../../layout/Header/Header";
import Swal from "sweetalert2";

const VACIO = { name: "", banco: "", cuenta: "", moneda: "MXN", observaciones: "" };

function ListadoCuentas() {
  const { user } = useContext(AuthContext);
  const URL_CUENTAS = process.env.REACT_APP_URL_CUENTAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const auth = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [cuentas, setCuentas] = useState([]);
  const [modal, setModal] = useState(false);
  const [idEdit, setIdEdit] = useState("");
  const [form, setForm] = useState(VACIO);
  const [validaBoton, setValidaBoton] = useState(true);

  const toggle = () => setModal(!modal);
  const set = (campo) => (e) => setForm({ ...form, [campo]: e.target.value });

  useEffect(() => {
    axios.get(URL_CUENTAS, auth)
      .then((response) => setCuentas(response.data))
      .catch(() => {});
  }, []); // eslint-disable-line

  function abrirNuevo() { setIdEdit(""); setForm(VACIO); toggle(); }
  function abrirEdit(a) {
    setIdEdit(a._id);
    setForm({
      name: a.name || "", banco: a.banco || "", cuenta: a.cuenta || "",
      moneda: a.moneda || "MXN", observaciones: a.observaciones || "",
    });
    toggle();
  }

  function guardar(event) {
    event.preventDefault();
    if (!form.name) {
      Swal.fire("Falta información", "El nombre es obligatorio", "warning");
      return;
    }
    setValidaBoton(false);

    const peticion = idEdit
      ? axios.patch(`${URL_CUENTAS}/${idEdit}`, form, auth)
      : axios.post(URL_CUENTAS, form, auth);

    peticion
      .then(() => {
        axios.post(URL_LOGS, {
          tipo: idEdit ? "Editar Cuenta" : "Crear Cuenta",
          detalle: form.name, user: user.id,
        }, auth);
        setValidaBoton(true);
        toggle();
        Swal.fire("¡Listo!", idEdit ? "Cuenta actualizada" : "Cuenta creada", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error", title: "Oops...", text: "Something went wrong!",
          footer: `${error.response?.data?.message || ""}`,
        });
      });
  }

  return (
    <>
      <Header />
      {user.menu_catalogos ? (
        <div className="card container col-sm-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <IcUniversity style={{ marginRight: 8, color: "#f59e0b" }} />
                Cuentas
              </h3>
              <p className="page-subtitle">Cuentas donde entra y sale el dinero</p>
            </div>
            <div className="page-actions">
              <Button color="success" size="sm" onClick={abrirNuevo}>
                <IcPlus style={{ marginRight: 6 }} />
                Nueva Cuenta
              </Button>
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Banco</th>
                <th>Cuenta</th>
                <th>Moneda</th>
                <th>Editar</th>
              </tr>
            </thead>
            <tbody>
              {cuentas
                .sort((a, b) => (a.name > b.name ? 1 : -1))
                .map((a) => (
                  <tr key={a._id}>
                    <td>{a.name}</td>
                    <td>{a.banco}</td>
                    <td>{a.cuenta}</td>
                    <td>{a.moneda}</td>
                    <td>
                      <Button color="info" size="sm" onClick={() => abrirEdit(a)}>
                        <IcEdit />
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{idEdit ? "Editar Cuenta" : "Nueva Cuenta"}</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <Label>Nombre</Label>
              <Input type="text" value={form.name} required onChange={set("name")} />
            </Col>
            <Col md={6}>
              <Label>Banco</Label>
              <Input type="text" value={form.banco} onChange={set("banco")} />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <Label>Número de cuenta</Label>
              <Input type="text" value={form.cuenta} onChange={set("cuenta")} />
            </Col>
            <Col md={6}>
              <Label>Moneda</Label>
              <Input type="select" value={form.moneda} onChange={set("moneda")}>
                <option value="MXN">MXN</option>
                <option value="USD">USD</option>
              </Input>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={12}>
              <Label>Observaciones</Label>
              <Input type="text" value={form.observaciones} onChange={set("observaciones")} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar} disabled={!validaBoton}>Guardar</Button>
          <Button color="secondary" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoCuentas;
